import Crud from '@/views/CheckAdjustmentRequest/Crud'
import Approve from '@/views/CheckAdjustmentRequest/Approve'
import Add from '@/views/CheckAdjustmentRequest/Add'

const routes = {
  path: '/check-adjustment-requests',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/check-adjustment-requests',
      name: 'list-check-adjustment-requests',
      component: Crud,
    },
    {
      path: '/check-adjustment-requests/add',
      name: 'add-check-adjustment-request',
      component: Add,
    },
    {
      path: '/check-adjustment-requests/approve',
      name: 'approve-check-adjustment-requests',
      component: Approve,
    },
    {
      path: '/check-adjustment-requests/approve/:id',
      name: 'approve-check-adjustment-request',
      component: Approve,
      props: true,
    },
  ],
}

export default routes
